import React, { useState, useEffect } from "react";
import { Row, Col, Dropdown} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { listFaqs } from "../actions/faqActions";
import DashHeader from "./DashHeader";

import FAQCard from "./FAQCard";
import FAQCardLoader from "./Preloader-faq";

function FAQs() {
  const dispatch = useDispatch();
  const faqList = useSelector((state) => state.faqList);
  const { faqs } = faqList;

  //Building set for category list
  let categories=new Set();
  
  for(var key in faqs){
    var faq=faqs[key];
    for(var key2 in faq.categories){
      categories.add(faq.categories[key2]);
    }    
  }

  let categoriesList=[...categories.values()];
  const [selectedCategory, setSelectedCategory] = useState();
  const [stateFAQs, setStateFAQs] = useState([]);
  const [queryingFAQs, setQueryingFAQs] = useState(true);

  function filterByCategory(category) {
      setStateFAQs((prev) =>
      !category ? faqs : faqs.filter((faq) => faq.categories.includes(category))
    );
    }

    useEffect(() => {
      setStateFAQs(faqs);
      setQueryingFAQs((queryingBots) => !queryingBots);
      
    }, [faqs]);

    useEffect(() => {
      filterByCategory(selectedCategory);
      // eslint-disable-next-line
    }, [selectedCategory]);


  useEffect(() => {
    dispatch(listFaqs());
  }, [dispatch]);



  return (
    <Col className="dashboard-scrollable-container" lg={9}>
      <DashHeader pageTitle={"FAQs"} />
      <Row className="dashboard-content-container">
        <Row className="dashboard-content-divider"></Row>
        {/* <Row>
          <Form>
            <Form.Select
              onChange={filterFAQTag}
              name="FAQtags"
              aria-label="Default select example"
              className="mb-3"
            >
              <option value="All">All</option>
              <option value="Employment">Employment</option>
              <option value="Starting a business">Starting a business</option>
              <option value="SME education">SME education</option>
              <option value="Corporate governance">Corporate governance</option>
              <option value="Human resources and labour relations">
                Human resources and labour relations
              </option>
              <option value="Legal updates">Legal updates</option>
              <option value="Work from home">Work from home</option>
            </Form.Select>
          </Form>
        </Row> */}
        <Row>
                <h2 className="ll-subtitle ll-feat-font">Legal FAQs</h2>
          </Row>
        <Row className="dashboard-content-divider"></Row>
        <Row align="center" className="mb-5" lg={4}>
            <Dropdown className="mx-auto d-flex justify-content-center">
              <Dropdown.Toggle
                variant="dark"
                className="lcn-button-brown px-5"
                id="dropdown"
              >
                {selectedCategory ? selectedCategory : "Filter by category"}
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item
                  name="All"
                  onClick={(e) => setSelectedCategory(null)}
                >
                  All
                </Dropdown.Item>
                {categoriesList.map((item) => {
                  return (
                    <Dropdown.Item
                      key={item}
                      name={item}
                      onClick={(e) =>
                        setSelectedCategory((prev) => e.target.name)
                      }
                    >
                      {item}
                    </Dropdown.Item>
                  );
                })}
              </Dropdown.Menu>
            </Dropdown>
        </Row>

        {/* FAQ Loader */}
        {stateFAQs.length>0 && stateFAQs.map((faq) => (
          <Col type='button' className="faq-card-parents" key={faq.id} lg={6} md={12} sm={12}>
            <FAQCard id={faq.id} title={faq.title} tag={faq.categories} />
          </Col>
        ))}
        {queryingFAQs && (
          <div>
        <Row>
          <Col className="px-3 py-3 my-1" lg={6} md={12} sm={12}>
            <FAQCardLoader />
          </Col>
          <Col className="px-3 py-3 my-1" lg={6} md={12} sm={12}>
            <FAQCardLoader />
          </Col>
          </Row>
          <Row>
          <Col className="px-3 py-3 my-1" lg={6} md={12} sm={12}>
            <FAQCardLoader />
          </Col>
          <Col className="px-3 py-3 my-1" lg={6} md={12} sm={12}>
            <FAQCardLoader />
          </Col>
          </Row>
          <Row>
          <Col className="px-3 py-3 my-1" lg={6} md={12} sm={12}>
            <FAQCardLoader />
          </Col>
          <Col className="px-3 py-3 my-1" lg={6} md={12} sm={12}>
            <FAQCardLoader />
          </Col>
        </Row></div>)}
      </Row>
    </Col>
  );
}

export default FAQs;
